import type { ActiveFilter, FilterOperator } from "@/components/ui/filter-panel";

export interface ProjectSequencesByJobParams {
  search?: string;
  job_id?: string;
  job_op?: "is" | "is_not";
  steps?: number;
  steps_op?: FilterOperator;
  enrollments?: number;
  enrollments_op?: FilterOperator;
}

const NUMBER_OPS = new Set<FilterOperator>(["is", "gt", "gte", "lt", "lte"]);

/** Parse a non-negative integer for by-job number filters (backend `ge=0`). */
function parseNonNegativeInt(raw: string): number | undefined {
  const n = Number.parseInt(raw.trim(), 10);
  if (!Number.isFinite(n)) return undefined;
  return Math.max(0, n);
}

/**
 * Map sheet toolbar search + ActiveFilter rows onto by-job query params.
 * Incomplete number filters (empty value) are omitted so the backend is
 * not hit with partial constraints while the user is still typing.
 */
export function activeFiltersToByJobParams(
  search: string,
  filters: ActiveFilter[],
): ProjectSequencesByJobParams {
  const params: ProjectSequencesByJobParams = {};
  const q = search.trim();
  if (q) params.search = q;

  for (const filter of filters) {
    if (filter.field === "job" && filter.value) {
      params.job_id = filter.value;
      params.job_op = filter.operator === "is_not" ? "is_not" : "is";
    }
    if (filter.field === "steps" && filter.value.trim() !== "") {
      const n = parseNonNegativeInt(filter.value);
      if (n !== undefined) {
        params.steps = n;
        params.steps_op = NUMBER_OPS.has(filter.operator)
          ? filter.operator
          : "gte";
      }
    }
    if (filter.field === "enrollments" && filter.value.trim() !== "") {
      const n = parseNonNegativeInt(filter.value);
      if (n !== undefined) {
        params.enrollments = n;
        params.enrollments_op = NUMBER_OPS.has(filter.operator)
          ? filter.operator
          : "gte";
      }
    }
  }

  return params;
}
